import UserPage from 'flarum/forum/components/UserPage';
import User from 'flarum/common/models/User';
import PictureList from '../components/PictureList';
import PictureListState from '../states/PictureListState';

export default class UserPicturePage extends UserPage {
    pictureList!: PictureListState

    oninit(vnode: any) {
        super.oninit(vnode);

        this.loadUser(m.route.param('username'));
    }

    show(user: User) {
        super.show(user);

        this.pictureList = new PictureListState({
            q: '-is:draft user:' + this.user!.username(),
        });
        this.pictureList.refresh();
    }

    content() {
        return m(PictureList, {
            state: this.pictureList,
            thumbnailAttrs: {
                showAlbum: true,
            },
        });
    }
}
